import addRoute from '@/router/add-route';

const Invoices = () => import('@/modules/invoices/invoices.vue');
const InvoiceDetails = () => import('@/modules/invoices/invoice-details.vue');

const invoices = [
    addRoute({
        name: 'invoices',
        path: '/invoices',
        component: Invoices,
    }),
    addRoute({
        name: 'invoice-details',
        path: '/invoices/:id', // id - invoice id
        component: InvoiceDetails,
        root: {label: 'Lists', name: 'lists'},
    }),
];

export default invoices;
